document.addEventListener("DOMContentLoaded", function () {
  // testimonial section slider js
  var swiper = new Swiper('.testimonial-container', {
    slidesPerView: 3,
    spaceBetween: 10,
    loop: false,
    pagination: {
      el: '.testimonial-swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      786: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
    }
  });

  // collection page category section slider js
  var category_swiper = new Swiper('.category-slider', {
    loop: false,
    slidesPerView: 8,
    spaceBetween: 10,
    slidesPerGroup: 8,
    pagination: {
      el: '.category-swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
      },
      480: {
        slidesPerView: 5,
        spaceBetween: 10,
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: 6,
        spaceBetween: 10,
        slidesPerGroup: 1,
      },
      992: {
        slidesPerView: 8,
        spaceBetween: 10,
        slidesPerGroup: 8,
      },
    }
  });

  // custom_multicolumn section js
  let sections = document.querySelectorAll(".custom_multicolumn .multicolumn-list__item");
  let observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        } else {
          entry.target.classList.remove("active");
        }
      });
    },
    { threshold: 0.5 }
  );

  sections.forEach((section) => {
    observer.observe(section);
  });

  // === collection-list section js ===
  let collectionItems = document.querySelectorAll(".collection-list-wrapper .collection-list__item");
  let collectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        } else {
          entry.target.classList.remove("active");
        }
      });
    },
    { threshold: 0.5 }
  );

  collectionItems.forEach((item) => {
    collectionObserver.observe(item);
  });

  let imagewithtext = document.querySelectorAll(".image-with-text");
  let imagewithtextObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("custom-image-with-text");
        } else {
          entry.target.classList.remove("custom-image-with-text");
        }
      });
    },
    { threshold: 0.5 }
  );

  imagewithtext.forEach((item) => {
    imagewithtextObserver.observe(item);
  });


  let allParents = document.querySelectorAll(".custom_child_links");
  let firstActiveSet = false;

  allParents.forEach(parent => {
    let grandchildMenu = parent.querySelector(".custom_grandchildlinks");
    let productWrapper = parent.querySelector(".itg_megamenu_product_wrapper");

    if (!firstActiveSet && grandchildMenu && grandchildMenu.children.length > 0) {
        let firstGrandchild = grandchildMenu.querySelector("li:first-child a");

      if (firstGrandchild) {
          parent.classList.add("active");
          grandchildMenu.classList.add("active");
          firstGrandchild.classList.add("active");
          if (productWrapper) productWrapper.classList.add("active");
          firstActiveSet = true;
      }
    } else {
      if (grandchildMenu) grandchildMenu.classList.remove("active");
      if (productWrapper) productWrapper.classList.remove("active");
    }
  });

  let menuLinks = document.querySelectorAll(".custom_mega-menu__content .mega-menu__link--level-2");
  menuLinks.forEach(link => {
    link.addEventListener("mouseenter", function () {
      document.querySelectorAll(".custom_child_links, .itg_grandchildlinks, .itg_megamenu_product_wrapper").forEach(el => {
          el.classList.remove("active");
      });

      let parent = this.closest(".custom_child_links");
      let grandchildMenu = parent.querySelector(".itg_grandchildlinks");
      let productWrapper = parent.querySelector(".itg_megamenu_product_wrapper");

      parent.classList.add("active");
      if (grandchildMenu) {
          grandchildMenu.classList.add("active");
          let firstGrandchild = grandchildMenu.querySelector("li:first-child a");
          if (firstGrandchild) firstGrandchild.classList.add("active");
      }
      if (productWrapper) productWrapper.classList.add("active");
  });
});

//------- header menu hover js--------
document.querySelectorAll(".header__inline-menu details").forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", "");
  });

  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });

  const ulElement = item.querySelector("ul");
  if (ulElement) {
    ulElement.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  }
});

// -------popup js ------
var popup = document.getElementById('custom_popup');
if (popup && !localStorage.getItem('popupShown')) {
  window.onload = function () {
    setTimeout(function () {
      document.getElementById('custom_popup').style.display = 'flex';

      document.getElementById('close-btn').onclick = function () {
        document.getElementById('custom_popup').style.display = 'none';
        localStorage.setItem('popupShown', 'true');
      };

      document.getElementById('popup_button').onclick = function () {
        document.getElementById('custom_popup').style.display = 'none';
        localStorage.setItem('popupShown', 'true');
      };

      // Close the pop-up when clicked outside of it
      window.onclick = function (event) {
        if (event.target == document.getElementById('custom_popup')) {
          document.getElementById('custom_popup').style.display = 'none';
          localStorage.setItem('popupShown', 'true');
        }
      };
    }, 1000);
  };
}
// ----product page tab js -----
const tabs = document.querySelectorAll('.tab-item');
const tabPanes = document.querySelectorAll('.tab-pane');
if (tabs) {
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const targetTab = tab.getAttribute('data-tab');
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      tabPanes.forEach(pane => pane.classList.remove('active'));
      document.getElementById(targetTab).classList.add('active');
    });
  });
}
// jdgm app tab 
let jdgmWidgetAll = document.querySelectorAll('.jdgm-preview-badge');
jdgmWidgetAll.forEach((jdgmWidget)=>{
  jdgmWidget.addEventListener('click',()=>{
    let reviewsTab = document.querySelector('.tab-item[data-tab="reviews"]');
    if (reviewsTab) {
        reviewsTab.click();
    }
  });
});


 


// background image js
document.querySelectorAll(".lazy-bg").forEach((el) => {
  const bgUrl = el.getAttribute("data-bg");
  if (bgUrl && bgUrl.trim() !== "") {
    new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.style.backgroundImage = `url(${bgUrl})`;
            observer.unobserve(el);
          }
        });
      },
      { rootMargin: "200px 0px", threshold: 0.1 }
    ).observe(el);
  }
});





if (document.body.classList.contains('Wholesale_customers')) {
    var subscriptionWidget = document.querySelector('.shopify_subscriptions_fieldset');
    if (subscriptionWidget) {
        subscriptionWidget.style.display = 'none';
    }
 }

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('subscribe') === 'true') {
    const subscribeRadio = document.querySelector('input[name="selling_plan_toggle"][value="subscription"]');
    if (subscribeRadio) {
        subscribeRadio.click();
    }
}
const cleanUrl = new URL(window.location.href);
['pr_prod_strat', 'pr_rec_id', 'pr_rec_pid', 'pr_ref_pid', 'pr_seq', 'subscribe'].forEach(param => {
    cleanUrl.searchParams.delete(param);
});
window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search);




});